import { render, staticRenderFns } from "./event-gallery-screen.html?vue&type=template&id=02affe9a&scoped=true&external"
import script from "./event-gallery-screen.js?vue&type=script&lang=js&external"
export * from "./event-gallery-screen.js?vue&type=script&lang=js&external"
import style0 from "./event-gallery-screen.scss?vue&type=style&index=0&id=02affe9a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02affe9a",
  null
  
)

export default component.exports